import { useSnapshot } from 'valtio'
import Head from 'next/head'
import { type ReactElement } from 'react'
import { globalUserProxy } from '../../../shared/proxies/globalUserProxy'
import Breadcrumbs from '../../../shared/components/ui/breadcrumbs/Breadcrumbs'
import { PageHeading } from '../../../shared/components/ui/headings/PageHeading'
import { determineBrowserTabName } from '../../../shared/themes/logoFunctions'
import ErrorBoundary from '../../../shared/components/errorBoundary/ErrorBoundary'
import { QuickLinksSection } from './QuickLinksSection/QuickLinksSection'
import { RecentSalesActivitySection } from './RecentSalesActivitySection/RecentSalesActivitySection'

export function HomePage (): ReactElement {
  const { user } = useSnapshot(globalUserProxy)
  return (
    <>
      <Head>
        <title>Home - {determineBrowserTabName()}</title>
      </Head>

      <Breadcrumbs breadcrumbs={[{ text: 'Dashboard' }]} />
      <PageHeading text={`Welcome ${user?.firstName || ''} ${user?.lastName || ''}`} />
      <ErrorBoundary>
        <QuickLinksSection />
      </ErrorBoundary>
      <div className="my-6" />
      <RecentSalesActivitySection />
    </>
  )
}
